import { call, put } from 'redux-saga/effects';
import { whiteboardDrafts } from 'utils/whiteboard/drafts/WhiteboardDraftStore';
import {
  draftLoaded,
  draftsAvailabilityResolved,
} from 'features/whiteboard/drafts/whiteboardDraftsSlice';

// Closing is part of disabling, not a step beside it: an error after init leaves the database
// open behind an unavailable flag, with the store's readers still answering from it.
export function* disableWhiteboardDraftsSaga() {
  yield call(whiteboardDrafts.close);
  yield put(draftsAvailabilityResolved(false));
  yield put(draftLoaded(null));
}
